import createConverter from './lib/create_converter';
import KbVariable from 'models/kb_variable';

export default createConverter(KbVariable);
